import { ModelBase, Property } from '@skylab-shared/core';

export class DocumentPaymentListItemModel extends ModelBase {
    @Property({ identifiable: true })
    public id: number;

    @Property()
    public onDocument: boolean;

    @Property()
    public date: Date;

    @Property()
    public value: number;
}
